import { useContext } from 'react';
import MuiRadio from '@mui/material/Radio';

import ControlLabel from 'ui/control-label';
import { RadioGroupSizeContext } from 'ui/radio-group/radio-group.context';
import type { RadioProps, RadioSize } from 'ui/radio/radio.types';

const DEFAULT_SIZE: RadioSize = 'medium';

const Radio = ({
  label,
  size,
  disabled,
  sx,
  ref,
  'aria-label': ariaLabel,
  'data-testid': dataTestId,
  ...rest
}: RadioProps) => {
  const groupSize = useContext(RadioGroupSizeContext);
  const resolvedSize = size ?? groupSize ?? DEFAULT_SIZE;
  const inputProps = {
    ref,
    'aria-label': ariaLabel,
    'data-testid': dataTestId,
  };
  const control = (
    <MuiRadio
      {...rest}
      size={resolvedSize}
      disabled={disabled}
      sx={label === undefined ? sx : undefined}
      slotProps={{ input: inputProps }}
    />
  );

  if (label === undefined) {
    return control;
  }

  return (
    <ControlLabel
      control={control}
      label={label}
      size={resolvedSize}
      disabled={disabled}
      sx={sx}
    />
  );
};

export default Radio;
